import axios, { AxiosInstance } from "axios";
import { GenericServiceRepository } from "@/models";
import { IRequest, IResponseWithArrayBody } from "./base";

/**
 * file này là file service dùng chung, định nghĩa logic của các phương thúc cần phải có
 * từ file repository
 * của 1 file service ở đối tượng cụ thể
 * các phần mở rộng (ở trong constructor):
 * @accesToken
 * @refreshToken
 * @prefix : domain url path (ví dụ : /TMFC007/TMF641/v5/CancelServiceOrder
 * @domain : trường hợp cần đổi port ( ví dụ : http://localhost:4000 )
 */
export class GenericService<TRequest extends IRequest, TResponse> implements GenericServiceRepository<TRequest, TResponse> {
  protected readonly axiosInstance: AxiosInstance;

  constructor(
    {
      accessToken,
      refreshToken,
      prefix,
      // domain = "https://api-dev-oda.vnpt.vn"
      domain = "http://10.165.68.7:30111"
    }: {
      accessToken?: string,
      refreshToken?: string,
      prefix: string,
      /**
       * chỗ này sau viết lại thành path,
       * @todo: tối ưu thêm cho phần này
       */
      domain?: string
    }
  ) {
    const token = accessToken || localStorage.getItem("access_token") || "";
    const refresh = refreshToken || localStorage.getItem("refresh_token") || "";
    const urlPath = domain + prefix;
    this.axiosInstance = axios.create({
      baseURL: urlPath,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        refresh_token: refresh
      },
    });
  }

  /**
   * hàm tạo đối tượng
   * @param data
   */
  async create(data: TRequest): Promise<TResponse> {
    const response = await this.axiosInstance.post<TResponse>("", data);
    return response.data;
  }


  async createList(data: TRequest): Promise<TResponse> {
    // Implement batch create if supported, otherwise fallback
    return Promise.resolve({} as TResponse);
  }

  /**
   * hàm này nhận vào là query dạng object , rồi từ object đó mới chuyển sang
   * dạng string theo cặp key-value
   * @param query object param đầu vào
   *
   * ------------------------
   *
   * # response
   * @data data trả về từ be
   * @statusCode mã code của response (belike 200,401,500,501)
   * @xTotalCount số lượng item tất cả
   * @xTotalResultCount: phần tử hiện tại
   */
  async findByQuery(query: Record<string, any>): Promise<IResponseWithArrayBody<TResponse>> {
    const response = await this.axiosInstance.get<TResponse[]>("", { params: query });
    console.log(response.headers["Content-Type"])
    console.log(response.headers["content-type"])
    console.log(response.headers["x-total-count"])
    console.log(response.headers["x-result-count"])
    return {
      data: response.data,
      statusCode: response.status,
      xTotalCount: response.headers["x-total-count"],
      xTotalResultCount: response.headers["x-result-count"]
    };
  }

  /**
   * tìm kiếm theo id
   * @param id
   */
  async findById(id: string) {
    const response = await this.axiosInstance.get(`/${id}`);
    return response.data;
  }

  /**
   * cập nhật dữ liệu theo id và trả về dữ liệu đã được cập nhật
   * @param id mã định danh
   * @param data dữ liệu cần gửi lên
   */
  async patch(id: string, data: TRequest): Promise<TResponse> {
    const response = await this.axiosInstance.patch<TResponse>(`/${id}`, data);
    return response.data;
  }

  async put(id: string, data: TRequest): Promise<TResponse> {
    const response = await this.axiosInstance.put<TResponse>(`/${id}`, data);
    return response.data;
  }

  /**
   * xoá dữ liệu theo id
   * @param id
   */
  async delete(id: string): Promise<void> {
    await this.axiosInstance.delete(`/${id}`);
  }
}
